import { useEffect, useMemo, useState } from 'react';
import { api } from '../lib/api';
import type { ServerVoice } from './useReadAloud';

/**
 * VOICE1-B, SLICE 0 (the 135th, 2026-10-11) - DOES THE SERVER HAVE A VOICE? Asked ONCE when the chat opens, and handed
 * to `useReadAloud` as its `server`.
 *
 * ⛔ UNTIL THE SERVER SAYS YES THERE IS NONE - and a question that fails, or answers anything else, is a no, quietly.
 *    With none, read aloud is exactly what it was: the phone's own voice.
 * ⛔ IT NEVER THROWS. 48 test files stand in for `api` with an object that has no voice calls at all; the call is made
 *    inside the promise, so a missing function is one more quiet no.
 */
export const useServerVoice = (): ServerVoice | null => {
  const [supplier, setSupplier] = useState<string | null>(null);

  useEffect(() => {
    Promise.resolve()
      .then(() => api.voiceStatus())
      .then((answer) => {
        const voice = answer?.voice;
        if (!voice || voice.available !== true || typeof voice.supplier !== 'string' || !voice.supplier) return;
        setSupplier(voice.supplier);
      })
      .catch(() => undefined);
  }, []);

  // The same object while nothing has changed: the read-aloud keeps it in a ref, and a new one every draw would be noise.
  return useMemo(
    () => (supplier ? { supplier, fetchClip: (text: string, signal: AbortSignal) => api.voiceClip(text, signal) } : null),
    [supplier],
  );
};
